// extracted by mini-css-extract-plugin
export default {"title":"home-page_title__bPQxm"};